import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "smartphone",
  "use": "smartphone-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"smartphone\">\n<path d=\"M17,23H7c-1.7,0-3-1.3-3-3V4c0-1.7,1.3-3,3-3h10c1.7,0,3,1.3,3,3v16C20,21.7,18.7,23,17,23z M7,3C6.4,3,6,3.4,6,4v16\n\tc0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V4c0-0.6-0.4-1-1-1H7z\" />\n<path d=\"M12,7c-0.6,0-1-0.4-1-1s0.4-1,1-1h0c0.6,0,1,0.4,1,1S12.6,7,12,7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol